import React, { useState } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { ErrorBox } from './common/ErrorBox';
import { MaterialPreview } from './common/MaterialPreview';
import { useFormContext } from 'react-hook-form';
import { InfoModal } from '../components/InfoModal';

export const MaterialPicker = ({ name, label, title, detailed_label, options, errors, validation, selectedMaterial, description }) => {
  const { register, setValue } = useFormContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleMaterialClick = (materialKey) => {
    setValue(name, materialKey, { shouldValidate: true });
  };

  return (
    <>
      <div className="bg-white/60 rounded-2xl shadow-sm border border-gray-200/60 p-3.5 transition-all duration-200 hover:bg-white/80 hover:shadow-md backdrop-blur-sm">
        <div className="flex justify-between items-start mb-2">
          <h2 className='text-base font-semibold text-gray-900'>{title}</h2>
          <AiOutlineInfoCircle
            className="text-gray-600 text-base cursor-pointer hover:text-gray-800 transition-colors flex-shrink-0"
            onClick={() => setIsModalOpen(true)}
          />
        </div>

        <p className="text-sm text-gray-600 mb-3">{detailed_label}</p>

        <div className="flex flex-wrap gap-x-4 gap-y-3 mt-1">
          {options.map((option, i) => (
            <div key={i} className="flex flex-col items-center" style={{ width: '56px' }}>
              <MaterialPreview
                materialKey={option.value}
                diameter={56}
                label={option.label}
                handleMaterialClick={handleMaterialClick}
                selected={selectedMaterial === option.value}
              />
              <label
                className="text-[9px] mt-1.5 text-center text-gray-600 dark:text-gray-400 font-medium leading-tight w-full break-words"
                title={option.label}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>

        <input type="hidden" {...register(name, validation)} />

        <ErrorBox errors={errors} />
      </div>

      <InfoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={title}
      >
        <p className="text-sm leading-relaxed">{description}</p>
      </InfoModal>
    </>
  );
};
